import { IconButton, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Download } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { MultiPictureUploadSubtypeResponse, MultiPictureUploadSubtypeDataModel } from "../../../../../../types/actionModule/subtypes/multiPictureUploadSubtype";

interface Props {
    subtype: MultiPictureUploadSubtypeResponse;
    subtypeData: MultiPictureUploadSubtypeDataModel;
}

export default function MultiPictureUploadSubtypeSummary(props: Props) {
    const { t } = useTranslation();

    return <Stack direction="row" sx={{ alignItems: "center" }}>
        <Typography>
            {t("incentivationPage.pictureUpload.numberUploadedImages", { count: props.subtypeData.images.length })}
        </Typography>

        {
            props.subtypeData.bundleDownloadUrl &&
            <Link to={props.subtypeData.bundleDownloadUrl} target="_blank">
                <IconButton>
                    <Download />
                </IconButton>
            </Link>
        }
    </Stack>
}
